export default "__VITE_ASSET__09a4f293__"